import React, { FC } from "react";
import { Container } from "../../../../components";
import { Icon, Text, Heading, Button } from "@telia/teddy";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../../../../../models";
import { FieldSet, FormRow, FormRowFormats, Input } from "../../../../forms";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { checkOrgName, checkOrgNumber, setShouldShowOrgOrNameInputField } from "../../../state/actions/businessActions";
import * as BUSINESS_DETAILS_SELECTORS from "../../../state/selectors/businessDetailsSelectors";
import TEXT from "../../../text-consts-b2b";
import OrgOrNameInput from "../../molecules/OrgOrNameInput/OrgOrNameInput";
import "./B2BOrganizationCard.less";

interface B2BOrganizationCardProps {
    brregNameSearch: {
        name: string;
        orgNumber: string;
    }[];
    organizationName: string;
    organizationNumber: string;
    shouldShowOrgOrNameInputField: boolean;
}

const formatOrgNr = (orgNumber: string) => {
    const onlyDigits = (orgNumber || "").replace(/\s/g, "");
    return onlyDigits.substr(0, 3) + " " + onlyDigits.substr(3, 3) + " " + onlyDigits.substr(6, 3);
};

const B2BOrganizationCard: FC<B2BOrganizationCardProps> = ({
    shouldShowOrgOrNameInputField,
    brregNameSearch,
    organizationName,
    organizationNumber,
}) => {
    const dispatch = useDispatch();

    return (
        <Container className="b2b-order__section b2b-org-card" size="large" whiteBg>
            <Heading mb="100" as="h2" variant="title-300">
                {TEXT.B2B_MANUAL_ORDER.ORDERER_CARD.HEADING}
            </Heading>
            <Text mb="100" className="b2b-org-card__paragraph">
                {TEXT.B2B_MANUAL_ORDER.ORDERER_CARD.FORM.PICK_COMPANY_HEADING}
            </Text>
            {shouldShowOrgOrNameInputField && (
                <div className="b2b-org-card__search-wrapper">
                    <OrgOrNameInput
                        checkOrgName={(name) => dispatch(checkOrgName(name))}
                        checkOrgNumber={(orgNumber) => dispatch(checkOrgNumber(orgNumber, "manualOrder"))}
                        businesses={brregNameSearch}
                        data-di-mask
                    />
                </div>
            )}
            {!shouldShowOrgOrNameInputField && (
                <div className="b2b-org-card__selected">
                    <div className="b2b-org-card__selected-wrapper">
                        <div className="b2b-org-card__selected-group">
                            <Icon name="premises" className="b2b-org-card__selected-icon" />
                            <span className="b2b-org-card__selected-org-name">{organizationName}</span>
                        </div>
                        <div className="b2b-org-card__selected-group">
                            <span className="b2b-org-card__selected-org-number-label">
                                {TEXT.B2B_MANUAL_ORDER.ORDERER_CARD.FORM.ORG_NUMBER_LABEL}
                            </span>
                            <span data-di-mask>{formatOrgNr(organizationNumber)}</span>
                        </div>
                    </div>
                    <div className="b2b-org-card__edit-button">
                        <Button
                            onClick={() => {
                                dispatch(setShouldShowOrgOrNameInputField(true));
                            }}
                            variant="secondary"
                        >
                            {TEXT.B2B_MANUAL_ORDER.ORDERER_CARD.FORM.CHANGE_COMPANY}
                        </Button>
                    </div>
                </div>
            )}
            <Text mb="100" className="b2b-org-card__paragraph">
                {TEXT.B2B_MANUAL_ORDER.ORDERER_CARD.FORM.ORDERER_PERSONALIA_HEADING}
            </Text>
            <FieldSet name="manualOrder" noMargin>
                <FormRow format={FormRowFormats.TWENTY_FIVE} data-di-mask>
                    <Input type="text" name={VALIDATION_FIELD.FIRST_NAME} label={TEXT.PERSONAL_DETAILS.FIRSTNAME} />
                    <Input type="text" name={VALIDATION_FIELD.LAST_NAME} label={TEXT.PERSONAL_DETAILS.LASTNAME} />
                    <Input
                        type="email"
                        name={VALIDATION_FIELD.CONTACT_EMAIL}
                        label={TEXT.PERSONAL_DETAILS.EMAIL}
                        placeholder="ola@nordmann.no"
                    />
                    <Input type="tel" name={VALIDATION_FIELD.CONTACT_PHONE} label={TEXT.COMMON.MOBILENUMBER} />
                </FormRow>
            </FieldSet>
            <Text mb="100" className="b2b-org-card__disclaimer">
                {TEXT.B2B_MANUAL_ORDER.ORDERER_CARD.FORM.SIGNATURE_REMINDER}
            </Text>
        </Container>
    );
};

const mapStateToProps = (state: RootState) => ({
    shouldShowOrgOrNameInputField: BUSINESS_DETAILS_SELECTORS.shouldShowOrgOrNameInputField(state),
    brregNameSearch: BUSINESS_DETAILS_SELECTORS.getBrregNames(state),
    organizationName: BUSINESS_DETAILS_SELECTORS.getOrganizationName(state),
    organizationNumber: BUSINESS_DETAILS_SELECTORS.getOrganizationNumber(state),
});

export default connect(mapStateToProps)(B2BOrganizationCard);
